import { ReactElement } from 'react';
import { UnitsInfoContainer } from './styles';
import Skeleton from 'react-loading-skeleton';

export function LoadingUnitsInfo(): ReactElement {
  return (
    <UnitsInfoContainer>
      <Skeleton
        height="166px"
        borderRadius="8px"
      />
      <Skeleton
        height="166px"
        borderRadius="8px"
      />
      <Skeleton
        height="166px"
        borderRadius="8px"
      />
      <Skeleton
        height="166px"
        borderRadius="8px"
      />
    </UnitsInfoContainer>
  );
}
